import React from "react";

export default class TripSwitchForm extends React.Component {

    constructor(){
        super();
        this.state = {
            allTrips: [],
            filteredTrips: [],
            filterRoute: "",
            filterRun: ""
        }
    }

    update = (evt) => {
        this.setState({[evt.target.id]: evt.target.value}, () => {
            this.runFilter();
        });
    }

    runFilter = () => {
        const filtered = this.state.allTrips.filter((trip) => {
            return (trip.Run.indexOf(this.state.filterRun) >= 0) && (trip.Route.indexOf(this.state.filterRoute) >= 0)
        });

        this.setState({filteredTrips: filtered});
    }

    componentDidMount(){
        const allTrips = [];

        this.props.unFilled.forEach((trip, index) => {
            trip.savedIndex = index;
            trip.isUnFilled = true;
            allTrips.push(trip);
        });

        this.props.options.forEach((trip, index) => {
            if(
                trip.DelayReason === "Cancelled" 
                || trip.DelayReason === "NoShow"
                || index === this.props.selectedIndex && !(this.props.isUnused || this.props.isPulled)
            ){
                return;
            }
            else if(trip.actual_departure_time || (trip.switched && trip.switched.tripFrom)){
                // don't select already departed trips
                // or trips that have already been switched-to
                return;
            }
            else if(trip.isUnFilled){
                // don't show the unfilled records again
                return
            }
            trip.savedIndex = index;
            allTrips.push(trip);
        });

        this.setState({allTrips, filteredTrips: allTrips});
    }

    render(){

        // console.log("TRIP SWITCH FORM PROPS", this.props);

        return (
            <div className="trip-switch-form">
                <div style={{
                    height: "92vh",
                    width: "90vw",
                    display: "flex",
                    flexDirection: "column",
                    position: "absolute",
                    top: "4vh",
                    left: "5vw",
                    zIndex: "100",
                    backgroundColor: "white",
                    border: "1px solid black",
                    boxShadow: "1vw 1vh 10vw rgba(0,0,0,0.7)",
                    padding: "1vw"
                }}>
                    <div style={{
                        marginBottom: "2vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <h3>Bus to Use:</h3>
                        <button className="option" onClick={this.props.closeForm}>Close</button>
                    </div>

                    <TripOption option={this.props.selectedTrip} isSelected={true} unUsed={this.props.isUnused} />
                    <br />

                    <div style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "space-between",
                        padding: "0 0 2vh",
                    }}>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "top"
                        }}>
                            <label><h3>Run</h3></label>
                            <input type="text" style={{
                                fontSize: "1rem",
                                padding: "6px"
                            }} 
                            id="filterRun"
                            value={this.state.filterRun}
                            onChange={this.update}
                            />
                        </div>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                        }}>
                            <label><h3>Route</h3></label>
                            <input type="text" style={{
                                fontSize: "1rem",
                                padding: "6px"
                            }} 
                            id="filterRoute"
                            value={this.state.filterRoute}
                            onChange={this.update}
                            />
                        </div>
                        <button className="option" style={{width: "25%"}}>Search for Trip</button>
                    </div>

                    <br />

                    <div style={{
                        overflowY: "scroll",
                        height: "65%",
                        margin: "1vh 0 2vh"
                    }}>
                        {
                            this.state.filteredTrips.map((trip, index) => {
                                return <TripOption 
                                    key={trip.TripNumber + "" + trip.savedIndex + "_" + trip.isUnFilled} 
                                    option={trip}
                                    unFilled={trip.isUnFilled}
                                    selectFunction={() => {
                                    const swap = window.confirm("Are you sure you want to switch this trip?");

                                    if(swap){
                                        if(this.props.isPulled){
                                            // the pullTrip version
                                            this.props.directSwitch(trip.savedIndex, null, trip.isUnFilled, false);
                                        }
                                        else{
                                            this.props.switchTrips.f(trip.savedIndex, trip.isUnFilled);
                                        }
                                        this.props.closeForm();
                                    }
                                }} />
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }
}

class TripOption extends React.Component {
    render() {

        console.log("TRIP OPTION", this.props.option);

        let firstChunkBackground = this.props.unFilled ? "#666" : null;
        let background = this.props.unFilled ? "#ddaa77" : "var(--soft-blue-hover)";

        firstChunkBackground = this.props.unUsed ? "#ddd" : firstChunkBackground;
        background = this.props.unUsed ? "#dd8888" : background;

        const style = {
            padding: "1vh",
            boxShadow: "0.5vh 0.5vh 1vh rgba(0,0,0,0.4)",
            background,
            display: "grid",
            alignItems: "center",
            justifyContent: "center",
            gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
            margin: "0 0 12px"
        };

        if(firstChunkBackground){
            style.background = `linear-gradient(to right, ${firstChunkBackground} 0%, ${firstChunkBackground} 15%, ${background} 15%, ${background} 100%)`;
            console.log("WE HAVE A BACKGROUND CHUNK!!!", firstChunkBackground, style.background);
        }

        let time = this.props.option.SchedDepTime;
        const timeIndex = time.indexOf(" ");
        time = time.substr(timeIndex);

        return (
            <div style={style}>
                {
                    !this.props.isSelected
                    ? <button className="option" style={{width: "fit-content"}} onClick={this.props.selectFunction}>Select</button>
                    : <span>
                    {
                        this.props.unUsed
                        ? <i className="fas fa-bus"></i>
                        : null
                    }
                    </span>
                }
                <div>
                    Run: <b>{this.props.option.run_id_original || this.props.option.Run}</b>
                </div>
                <div>
                    Route: <b>{this.props.option.Route}</b>
                </div>
                <div>
                    {
                        this.props.option.vehicle_id || this.props.option.vehicle_id_original
                        ? <span>Bus #: <b>{
                                (
                                    (this.props.option.driver_replaced || this.props.option.driver_reassigned) 
                                    ? this.props.option.vehicle_id_original 
                                    : this.props.option.vehicle_id
                                )
                            }</b></span>
                        : "_"
                    }
                </div>
                <div>
                    <b>{time}</b>
                </div>
            </div>
        )
    }
}